import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "style.css";

// Extensions vary per file; 8 and 10 are missing from the folder
// thumbs/ contains 450px JPEGs for the grid; full-res used in the lightbox
const images = [
  {
    src: "/images/gallery/1.jpg",
    thumb: "/images/gallery/thumbs/1.jpg",
    alt: "SURF photo 1",
  },
  {
    src: "/images/gallery/2.jpeg",
    thumb: "/images/gallery/thumbs/2.jpg",
    alt: "SURF photo 2",
  },
  {
    src: "/images/gallery/3.jpg",
    thumb: "/images/gallery/thumbs/3.jpg",
    alt: "SURF photo 3",
  },
  {
    src: "/images/gallery/4.jpeg",
    thumb: "/images/gallery/thumbs/4.jpg",
    alt: "SURF photo 4",
  },
  {
    src: "/images/gallery/5.jpg",
    thumb: "/images/gallery/thumbs/5.jpg",
    alt: "SURF photo 5",
  },
  {
    src: "/images/gallery/6.png",
    thumb: "/images/gallery/thumbs/6.jpg",
    alt: "SURF photo 6",
  },
  {
    src: "/images/gallery/7.jpg",
    thumb: "/images/gallery/thumbs/7.jpg",
    alt: "SURF photo 7",
  },
  {
    src: "/images/gallery/9.jpg",
    thumb: "/images/gallery/thumbs/9.jpg",
    alt: "SURF photo 9",
  },
  {
    src: "/images/gallery/11.jpg",
    thumb: "/images/gallery/thumbs/11.jpg",
    alt: "SURF photo 11",
  },
  {
    src: "/images/gallery/12.jpg",
    thumb: "/images/gallery/thumbs/12.jpg",
    alt: "SURF photo 12",
  },
  {
    src: "/images/gallery/13.jpg",
    thumb: "/images/gallery/thumbs/13.jpg",
    alt: "SURF photo 13",
  },
  {
    src: "/images/gallery/14.jpg",
    thumb: "/images/gallery/thumbs/14.jpg",
    alt: "SURF photo 14",
  },
  {
    src: "/images/gallery/15.jpg",
    thumb: "/images/gallery/thumbs/15.jpg",
    alt: "SURF photo 15",
  },
  {
    src: "/images/gallery/16.jpg",
    thumb: "/images/gallery/thumbs/16.jpg",
    alt: "SURF photo 16",
  },
  {
    src: "/images/gallery/17.jpg",
    thumb: "/images/gallery/thumbs/17.jpg",
    alt: "SURF photo 17",
  },
  {
    src: "/images/gallery/18.jpg",
    thumb: "/images/gallery/thumbs/18.jpg",
    alt: "SURF photo 18",
  },
  {
    src: "/images/gallery/19.jpg",
    thumb: "/images/gallery/thumbs/19.jpg",
    alt: "SURF photo 19",
  },
  {
    src: "/images/gallery/20.jpg",
    thumb: "/images/gallery/thumbs/20.jpg",
    alt: "SURF photo 20",
  },
  {
    src: "/images/gallery/21.jpg",
    thumb: "/images/gallery/thumbs/21.jpg",
    alt: "SURF photo 21",
  },
  {
    src: "/images/gallery/22.jpg",
    thumb: "/images/gallery/thumbs/22.jpg",
    alt: "SURF photo 22",
  },
  {
    src: "/images/gallery/23.jpg",
    thumb: "/images/gallery/thumbs/23.jpg",
    alt: "SURF photo 23",
  },
  {
    src: "/images/gallery/24.jpg",
    thumb: "/images/gallery/thumbs/24.jpg",
    alt: "SURF photo 24",
  },
];

const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = (i: number) => {
    setIndex(i);
    setOpen(true);
  };

  return (
    <div className="gallery-page">
      <h1 className="gallery-heading">Gallery</h1>
      <div className="gallery-grid">
        {images.map((img, i) => (
          <button
            key={img.src}
            className="gallery-tile"
            onClick={() => openAt(i)}
            aria-label={`Open ${img.alt}`}
          >
            <img
              src={img.thumb}
              alt={img.alt}
              loading="lazy"
              className="gallery-tile-img"
            />
          </button>
        ))}
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={images.map((img) => ({ src: img.src, alt: img.alt }))}
      />
    </div>
  );
};

export default Gallery;
